// This file was automatically generated by the Soy compiler.
// Please don't edit this file by hand.
// source: src/com/yext/m4/confcode/adminconsole/js/confirmationmodal/confirmationModal.soy

/**
 * @fileoverview Templates in namespace yext.m4.confcode.adminconsole.confirmationmodal.template.
 * @public
 */

goog.provide('yext.m4.confcode.adminconsole.confirmationmodal.template');
goog.require("yext");

goog.require('goog.soy');
goog.require('soy');
goog.require('soydata.VERY_UNSAFE');


/**
 * @param {!yext.m4.confcode.adminconsole.confirmationmodal.template.main.Params} opt_data
 * @param {(?goog.soy.IjData|?Object<string, *>)=} opt_ijData
 * @return {!goog.soy.data.SanitizedHtml}
 * @suppress {checkTypes}
 */
yext.m4.confcode.adminconsole.confirmationmodal.template.main = function(opt_data, opt_ijData) {
  opt_ijData = /** @type {!goog.soy.IjData} */ (opt_ijData);
  /** @type {?} */
  const environment = opt_data.environment;
  /** @type {?} */
  const businessId = opt_data.businessId;
  /** @type {?} */
  const businessName = opt_data.businessName;
  /** @type {?} */
  const hasDependencyFile = opt_data.hasDependencyFile;
  /** @type {?} */
  const missingDependencyBehavior = opt_data.missingDependencyBehavior;
  /** @type {?} */
  const isDry = opt_data.isDry;
  /** @type {?} */
  const isComprehensive = opt_data.isComprehensive;
  let $tmp;
  if (isDry) {
    $tmp = '<p><b>This is a dry apply</b>. The actions that would be taken by an apply operation will be shown, but the changes will <em>not</em> be persisted</p>';
  } else if (isComprehensive) {
    $tmp = '<p><b>This is a comprehensive apply</b>. Resources removed from the admin console <em>will be</em> deleted.</p>';
  } else {
    $tmp = '<em>Press confirm to apply the resources!</em>';
  }
  return soydata.VERY_UNSAFE.ordainSanitizedHtml('<div class="modal fade js-modal" id="modal-confirmation" tabindex="-1" role="dialog" aria-labelledby="modal-title" aria-hidden="true"' + (goog.DEBUG && soy.$$debugSoyTemplateInfo ? ' data-debug-soy="yext.m4.confcode.adminconsole.confirmationmodal.template.main src/com/yext/m4/confcode/adminconsole/js/confirmationmodal/confirmationModal.soy:11"' : '') + '><div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content js-dialog-content"><div class="modal-header"><h5 class="modal-title" id="modal-title">Are you sure you want to apply the resources?</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" class="x-icon"></span></button></div><form class="js-confirmation-modal-form"><input type="hidden" class="js-business-id" value="' + soy.$$escapeHtmlAttribute(businessId) + '"><div class="modal-body js-modal-body"><h6>Account Name:</h6><p>' + soy.$$escapeHtml(businessName) + '</p><h6>Environment:</h6><p>' + soy.$$escapeHtml(environment) + '</p>' + (!soy.$$equals(environment, 'Prod') && soy.$$coerceToBoolean(hasDependencyFile) ? '<h6>If Dependencies are Missing:</h6>' + (soy.$$equals(missingDependencyBehavior, 'ADD') ? '<p>Add missing dependencies</p>' : '') + (soy.$$equals(missingDependencyBehavior, 'IGNORE') ? '<p>Ignore missing dependencies and continue applying</p>' : '') + (soy.$$equals(missingDependencyBehavior, 'ERROR') ? '<p>Stop applying and display an error message</p>' : '') : '') + $tmp + '</div><div class="modal-footer js-modal-footer"><button type="button" class="btn btn-cancel js-cancel-button" data-dismiss="modal">Cancel</button><button type="submit" class="btn btn-primary js-confirm-apply sl-confirm-apply">Confirm</button></div></form></div></div></div><button type="button" class="js-confirmation-modal-toggle" data-toggle="modal" data-target="#modal-confirmation" style="display: none;"' + (goog.DEBUG && soy.$$debugSoyTemplateInfo ? ' data-debug-soy="yext.m4.confcode.adminconsole.confirmationmodal.template.main src/com/yext/m4/confcode/adminconsole/js/confirmationmodal/confirmationModal.soy:58"' : '') + '></button>');
};
/**
 * @typedef {{
 *  environment: ?,
 *  businessId: ?,
 *  businessName: ?,
 *  hasDependencyFile: ?,
 *  missingDependencyBehavior: ?,
 *  isDry: ?,
 *  isComprehensive: ?,
 * }}
 */
yext.m4.confcode.adminconsole.confirmationmodal.template.main.Params;
if (goog.DEBUG) {
  /** @type {string} */
  yext.m4.confcode.adminconsole.confirmationmodal.template.main.soyTemplateName = 'yext.m4.confcode.adminconsole.confirmationmodal.template.main';
}
